<style>
  .vid {
    position: absolute;
    top: 40%;
    left: calc(50% - 25px);
    width: 64px !important;
    height: 64px;
    -webkit-transition: all .5s;
    /* For Safari 3.1 to 6.0 */
    transition: all .5s;
  }

  .vid:hover {
    transform: scale(1.3);
    cursor: pointer;
  }
</style>
<!-- Modal -->
<dx-popup class="popup" width="auto" height="auto" [showTitle]="true" [position]="position" [title]="titulo"
  [dragEnabled]="true" [closeOnOutsideClick]="true" [(visible)]="popupVisible">
  <div *dxTemplate="let data of 'content'">
    <div [innerHTML]="texto"></div>
    <dx-button style="float: right;padding: 5px;" text="cerrar" (onClick)="popupVisible=!popupVisible">
    </dx-button>
  </div>
</dx-popup>
<dx-popup class="popup" width="80%" height="auto" [showTitle]="true" [title]="video.Descripcion" [position]="position"
  [dragEnabled]="true" [closeOnOutsideClick]="true" [(visible)]="videoShow">
  <div *dxTemplate="let data of 'content'">
    <div [innerHTML]="video.url| safe: 'html'"></div>
  </div>
</dx-popup>
<div class="page-content" style="padding-bottom: 0px;">
  <!-- Slider -->
  <app-banner></app-banner>
  <br><br>
  <!-- Services End -->

  <!-- Latest News -->
  <div class="section-full content-inner-1 box-shadow">
    <div class="container">
      <div class="row">
        <div class="section-head text-center">
          <h2 class="h2">Noticias</h2>
          <div class="dez-separator-outer">
            <div class="dez-separator bg-primary style-liner"></div>
          </div>
        </div>
      </div>
      <div class="section-content">
        <div class="blog-carousel mfp-gallery gallery owl-btn-center-lr">
          <ng-container *ngFor="let item of noticias">
            <app-news [title]="item.titulo | titlecase" [description]="item.texto | truncate : 100" [id]="item.id"
              [fecha]="item.fecha_publicar" [image]="item.imagen">
            </app-news>
          </ng-container>
        </div>
        <a href="" style="float: right;" routerLink="/noticias">ver más</a>
      </div>
    </div>
  </div>
  <div class="section-full bg-img-fix content-inner bg-white our-projects-galery"
    style="background-image:url('/assets/4.jpg');">
    <div class="container">
      <!-- tabs nav left & backgound tabs END -->
      <!-- tabs nav left & content border -->
      <div class="col-md-9">
        <h2 class="text-uppercase m-b30">Multimedia</h2>
        <div class="testimonial-one mfp-gallery gallery owl-btn-center-lr">
          <div *ngFor="let item of videos" class="item">
            <div class="ow-carousel-entry">
              <div class="ow-entry-media">
                <img (click)="showVideo(item)" class="vid" src="/assets/play.png" alt="">
                <img src="https://img.youtube.com/vi/{{item.Archivo}}/hqdefault.jpg" alt="">
              </div>
              <div class="ow-entry-content">
                <div class="ow-entry-title" style="text-align: center;font-size: 12px;">
                  {{item.Descripcion}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <a style="float: right;" routerLink="/videos"> ver más</a>
        <!-- tabs nav left & content border END -->
      </div>
      <div class="clearfix p-b10">
        <!-- tabs nav left & backgound tabs -->
        <div class="col-md-3">
          <h2 class="text-uppercase m-b10">Documentos Destacados</h2>

          <div class="testimonial-one mfp-gallery gallery owl-btn-center-lr col-md-3">
            <div *ngFor="let item of importante;let i=index;" class="item">
              <div class="ow-carousel-entry">
                <div class="ow-entry-media">

                  <a *ngIf="item.tipo=='url'" href="{{domain}}{{item.url}}"><img style="width: 250px;"
                      src="{{domain}}{{item.imagen}}" alt=""></a>
                  <a *ngIf="item.tipo!='url'" href="content/{{item.url}}"><img style="width: 250px;"
                      src="{{domain}}{{item.imagen}}" alt=""></a>

                </div>
                <div class="ow-entry-content">
                  <div class="ow-entry-title" style="text-align: center;font-size: 12px;">
                    {{item.titulo}}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>


      </div>
    </div>
  </div>


  <!-- Latest News END -->

  <div class="section-full content-inner-1 box-shadow">
    <div class="container">
      <div class="row">
        <div class="section-head text-center">
          <h2 class="h2">Documentos Importantes</h2>
          <div class="dez-separator-outer">
            <div class="dez-separator bg-primary style-liner"></div>
          </div>
        </div>
      </div>
      <div class="section-content">
        <div class="img-carousel-content mfp-gallery gallery owl-btn-center-lr">
          <div *ngFor="let item of documentos" class="item">
            <div class="ow-carousel-entry">
              <div class="ow-entry-media dez-img-effect zoom-slow">
                <a *ngIf="item.tipo=='url'" href="{{domain}}{{item.url}}">
                  <img style="height: 180px;" src="{{domain}}{{item.imagen}}" alt="">
                </a>
                <a *ngIf="item.tipo=='content'" routerLink="/content/{{item.url}}">
                  <img style="height: 180px;" src="{{domain}}{{item.imagen}}" alt="">
                </a>
              </div>
              <div class="ow-entry-content">
                <div class="ow-entry-title" style="text-align: center;font-size: 12px;">
                  <a *ngIf="item.tipo=='url'" href="{{domain}}{{item.url}}">
                    {{item.titulo}}
                  </a>
                  <a *ngIf="item.tipo=='content'" routerLink="/content/{{item.url}}">
                    {{item.titulo}}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Our Awesome Services -->

  <!-- Our Awesome Services END -->
  <!-- Stats -->

  <!-- Stats End -->
  <!-- Team member -->

  <!-- Team member END -->
  <!-- Our Activities  -->
  <!-- Our Activities END -->
  <!-- Our Gallery -->
  <!-- Our Gallery END -->
  <!-- Testimonials -->
  <div class="section-full bg-img-fix content-inner overlay-black-dark" style="background-image:url('/assets/4.jpg');">
    <div class="container">
      <div class="section-head  text-center text-white">
        <h2 class="h2">Entidades bajo tuición</h2>
        <div class="dez-separator-outer">
          <div class="dez-separator bg-primary style-liner"></div>
        </div>
      </div>
      <div class="section-content">
        <div>

          <!-- Nav tabs -->
          <ul class="client-pic text-center m-t20">
            <li>
              <a href="http://www.ine.gob.bo/">
                <img src="/assets/links/ine.png" alt="" />
              </a>
            </li>
            <li>
              <a href="http://www.fndr.gob.bo/es/">
                <img src="/assets/links/fndr.png" alt="" />
              </a>
            </li>
            <li>
              <a href="http://www.udape.gob.bo/">
                <img src="/assets/links/udape.png" alt="" />
              </a>
            </li>
            <li>
              <a href="http://www.fps.gob.bo/">
                <img src="/assets/links/fps.png" alt="" />
              </a>
            </li>
            <li>
              <a href="http://www.fondesif.gob.bo/">
                <img src="/assets/links/fondesif.png" alt="" />
              </a>
            </li>
            <li>
              <a href="http://www.bdp.com.bo/">
                <img src="/assets/links/bdp.jpg" alt="" />
              </a>
            </li>
            <li>
              <a href="http://www.ademaf.gob.bo/">
                <img src="/assets/links/ademaf.png" alt="" />
              </a>
            </li>

          </ul>
          <!-- Tab panes -->
        </div>
      </div>
    </div>
  </div>
  <!-- Testimonials End -->
  <img class="cloudsright rellax" src="/assets/NUEVO_LOGO_MPD.png" style="height: 80px;" data-rellax-speed="8">


</div>
<div class="ls-popup">
  <div id="slider" style="width:500px;height:500px;margin:0 auto;margin-bottom: 0px;">

    <!-- Slide 1-->
    <div class="ls-slide" data-ls="overflow:true; kenburnsscale:1.2; parallaxtype:3d; parallaxrotate:20;">
      <div
        style="top:90px; left:90px; text-align:initial; font-weight:400; font-style:normal; text-decoration:none; mix-blend-mode:normal; width:370px; height:370px; background:#ffffff; border-radius:500px; font-size:16px;"
        class="ls-l"
        data-ls="showinfo:1; durationin:1900; easingin:easeOutElastic; fadein:false; scalexin:0; scaleyin:0; loop:true; loopoffsetx:-20; loopoffsety:20; loopduration:4000; loopeasing:easeInOutSine; loopcount:-1; loopyoyo:true; parallax:true; parallaxlevel:4;">
      </div>
      <div
        style="top:100px; left:100px; text-align:initial; font-weight:400; font-style:normal; text-decoration:none; mix-blend-mode:normal; width:350px; height:350px; background:#337ab7; border-radius:500px; font-size:16px;"
        class="ls-l"
        data-ls="showinfo:1; durationin:1500; easingin:easeOutElastic; fadein:false; scalexin:0; scaleyin:0; loop:true; loopoffsetx:-20; loopoffsety:20; loopduration:4000; loopeasing:easeInOutSine; loopcount:-1; loopyoyo:true; parallax:true; parallaxlevel:4;">
      </div>
      <img onclick="location.href='http://www.planificacion.gob.bo/uploads/FONDO_CONCURSABLE_COCHABAMBA1.pdf'"
        src="/assets/fc2.png" class="ls-l" alt=""
        style="cursor: pointer;top:213px; left:96px; text-align:initial; font-weight:400; font-style:normal; text-decoration:none; mix-blend-mode:normal; width:300px; height:150px;"
        data-ls="showinfo:1; offsetxin:100lw; durationin:2000; rotatein:50; parallax:true; parallaxlevel:6;">
      <p style="display: none;top:150px; left:200px; text-align:center; font-weight:400; font-style:normal; text-decoration:none; mix-blend-mode:normal; font-family:Montserrat; color:#ffffff; width:150px; line-height:60px; font-size:40px; white-space:normal;"
        class="ls-l"
        data-ls="showinfo:1; durationin:500; delayin:1200; scalexin:0; scaleyin:0; parallax:true; parallaxlevel:4; rotation:0;">
      </p>
      <p style="box-shadow: -30px 20px 20px rgba(0,0,0,.3); cursor:pointer;top:364px; left:287px; text-align:center; font-weight:400; font-style:normal; text-decoration:none; mix-blend-mode:normal; padding-top:5px; padding-right:20px; border-bottom:4px solid #e05350; padding-bottom:5px; padding-left:20px; font-family:Montserrat; color:#ffffff; background:#e05353; border-radius:100px; font-size:20px;"
        class="ls-l ls-close-popup"
        data-ls="showinfo:1; offsetyin:100lh; delayin:1200; rotatexin:-70; hover:true; hoverdurationin:1000; hoverdurationout:500; hovereasingin:easeOutElastic; hovereasingout:easeInOutQuint; hoverscalex:1.1; hoverscaley:1.1; parallax:true; parallaxlevel:10; rotation:0;">
        Cerrar</p>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/pages/index/index.component.html